module.exports = __webpack_public_path__ + "img/FK.bc23430f.png";